import React from 'react';

export default function RightArrow({ fill, className }) {
  return (
    <svg className={className} width='16' height='24' viewBox='0 0 16 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M2.93891 2L13.2944 11.8889L2.7062 22' stroke={fill} strokeWidth='4' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
